export default __webpack_public_path__ + "static/media/390.8e92d8e8.gif";